import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import LoginTemplate from "../templates/login/LoginTemplate";
import { useAuth } from "../context/AuthContext";

const getErrorMessage = (err) => {
  if (!err?.response) {
    return "Impossible de joindre le serveur. Vérifiez votre connexion.";
  }
  const { status, data } = err.response;
  if (status === 400 || status === 401) {
    return "Adresse e-mail ou mot de passe incorrect.";
  }
  if (status === 429) {
    return "Trop de tentatives. Réessayez dans quelques minutes.";
  }
  return data?.message || data?.detail || "La connexion a échoué. Réessayez.";
};

const LoginScreen = () => {
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const redirectTo = location.state?.from?.pathname || "/";

  const handleSubmit = async ({ email, password, remember }) => {
    if (!email || !password) {
      setError("Renseignez votre adresse e-mail et votre mot de passe.");
      return;
    }

    setLoading(true);
    setError("");
    try {
      await login({ email, password, remember });
      navigate(redirectTo, { replace: true });
    } catch (err) {
      setError(getErrorMessage(err));
      setLoading(false);
    }
  };

  return (
    <LoginTemplate onSubmit={handleSubmit} loading={loading} error={error} />
  );
};

export default LoginScreen;